import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Spin,
  message,
  Radio,
  Space,
  Checkbox,
} from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { RESEARCH_TYPE } from "../../utils/consts";

const { Option } = Select;

export default class ConsentFormChild extends Component {
  constructor(props) {
    super(props);
    this.state = {
      i_accept_checkbox: "",
      loading: false,
      user_type: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Consent form signed?") {
                if (item.value == "Yes") {
                  this.setState({ i_accept_checkbox: item.value });
                  this.props.set_active_step(1);
                }
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save_details = () => {
    if (!this.state.i_accept_checkbox) {
      message.warning("Please accept consent form assigned");
      return;
    }
    let questions = [
      {
        parent_field: "Consent form signed?",
        field: "Consent form signed?",
        value: "Yes",
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "0",
      type: "consent_form",
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              this.props.set_active_step(1);
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        // message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  logout = () => {
    localStorage.removeItem("ap_eals_id");
    localStorage.clear();
    localStorage.clear();
    window.location.assign("/");
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>CONSENT FORM</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group pdf-div">
              <iframe
                src="./assets/documents/ecas-study-consent-form.pdf#toolbar=0"
                title="Consent Form"
                width="100%"
                height="600px"
              ></iframe>
            </div>
            <div className="form-group">
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({ i_accept_checkbox: event.target.checked })
                }
                checked={this.state.i_accept_checkbox == true ? true : false}
                style={{ fontSize: 17 }}
              >
                I Accept <span className="text-danger">*</span>
              </Checkbox>
            </div>
            <button
              className="submit-button"
              style={{ padding: "9px 15px 10px 20px" }}
              onClick={() => this.save_details()}
            >
              Save & Next{" "}
              <box-icon
                name="chevron-right"
                color="#fff"
                style={{ position: "relative", top: 1 }}
              ></box-icon>
            </button>
          </div>
        </Spin>
      </div>
    );
  }
}
